import { isLoggedIn } from '@onesource/services';
import { useRouter } from '@tanstack/react-router';
import { FC, ReactNode, useEffect } from 'react';

import { RedirectLoader } from '../redirect-loader';

export const AuthGuard: FC<{ children: ReactNode }> = props => {
  const { children } = props;
  const router = useRouter();

  useEffect(() => {
    if (!isLoggedIn()) {
      const timer = setTimeout(() => {
        const search = new URLSearchParams(window.location.search);
        const returnUrl = search.get('return_url');
        const loginUrl = returnUrl ? `/auth/login?return_url=${encodeURIComponent(returnUrl)}` : '/auth/login';
        router.history.push(loginUrl);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [router]);

  if (!isLoggedIn()) {
    return <RedirectLoader />;
  }

  return children;
};
